// Generated by ReScript, PLEASE EDIT WITH CARE


var pageTitle = "Porter store";

var tabInProgress = "In progress";

var tabCompleted = "Confirmed";

var searchPlaceholder = "Search";

var downloadCsv = "Download csv";

var headerOrderDetails = "Order details";

var headerOrderStatus = "Order status";

var headerPartnerName = "Partner name";

var headerCity = "City";

var headerPhoneNumber = "Phone number";

var loadingOrders = "Loading orders...";

var loadingMoreOrders = "Loading more orders...";

var loadingOrderDetails = "Loading order details...";

var noOrdersFound = "No orders found";

var noOrdersDescription = "Try adjusting your search or filter criteria.";

var applyFilter = "Apply";

var selectAllCities = "Select all cities";

var downloadModalTitle = "Download .csv file";

var downloadModalDesc = "Your .csv file will include all orders based on the currently applied filters.";

var downloadModalCancel = "Cancel";

var downloadModalDownload = "Download";

var statusLabel = "Status:";

var statusConfirmed = "Confirmed";

var markStatusAs = "MARK STATUS AS";

var createdOnPrefix = "Created on ";

var lastUpdatedByPrefix = "Last updated by ";

var lastUpdatedAtSeparator = " at ";

var sectionDriverDetails = "Driver details";

var sectionAddressDetails = "Address details";

var sectionAddMoreItems = "Add more items";

var itemsOrderedPrefix = "Items ordered (";

var labelPartnerName = "Partner name";

var labelPhoneNumber = "Phone number";

var labelPartnerId = "Partner ID";

var labelAddressLine1 = "Address line 1";

var labelAddressLine2 = "Address line 2";

var labelCity = "City";

var labelState = "State";

var labelPincode = "Pincode";

var orderTotalLabel = "Order total =";

var btnSave = "Save";

var btnSendPaymentLink = "Pay via Wallet";

var rupeeSymbol = "\u20B9";

var toastSaveSuccess = "Changes saved successfully";

var toastSaveFailure = "Unable to save order. Try again";

var toastPaymentSuccess = "Payment deducted successfully";

var toastPaymentFailure = "Something went wrong. Try again";

var toastOrderDetailFailure = "Unable to load order details. Try again";

export {
  pageTitle ,
  tabInProgress ,
  tabCompleted ,
  searchPlaceholder ,
  downloadCsv ,
  headerOrderDetails ,
  headerOrderStatus ,
  headerPartnerName ,
  headerCity ,
  headerPhoneNumber ,
  loadingOrders ,
  loadingMoreOrders ,
  loadingOrderDetails ,
  noOrdersFound ,
  noOrdersDescription ,
  applyFilter ,
  selectAllCities ,
  downloadModalTitle ,
  downloadModalDesc ,
  downloadModalCancel ,
  downloadModalDownload ,
  statusLabel ,
  statusConfirmed ,
  markStatusAs ,
  createdOnPrefix ,
  lastUpdatedByPrefix ,
  lastUpdatedAtSeparator ,
  sectionDriverDetails ,
  sectionAddressDetails ,
  sectionAddMoreItems ,
  itemsOrderedPrefix ,
  labelPartnerName ,
  labelPhoneNumber ,
  labelPartnerId ,
  labelAddressLine1 ,
  labelAddressLine2 ,
  labelCity ,
  labelState ,
  labelPincode ,
  orderTotalLabel ,
  btnSave ,
  btnSendPaymentLink ,
  rupeeSymbol ,
  toastSaveSuccess ,
  toastSaveFailure ,
  toastPaymentSuccess ,
  toastPaymentFailure ,
  toastOrderDetailFailure ,
  
}
/* No side effect */
